export default __webpack_public_path__ + "static/media/News.17d013b1.svg";